import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface VerifyOTPWithRegisterInterface {
  data: string
  serverRef: string
  name: string
  email: string
}

export const useVerifyOTPWithRegister = () => {
  const mutate = useMutation(({ data, serverRef, name, email }: VerifyOTPWithRegisterInterface) => {
    return postAPI('/user-api/verify_otp_with_reg', {
      data,
      serverRef,
      name,
      email
    })
  })

  return mutate
}

export default useVerifyOTPWithRegister
